export const environment = {
    production: false,
    msalConfig: {
        auth: {
            clientId: "671c5a58-5442-4990-a26a-8380a392d952",
            authority: "https://testb2cminster.b2clogin.com/testb2cminster.onmicrosoft.com/b2c_1_signin",
            noMfaAuthority: "https://testb2cminster.b2clogin.com/testb2cminster.onmicrosoft.com/b2c_1_nomfasignin",
            authorityDomain: "testb2cminster.b2clogin.com",
            redirectUri: "https://register-test.minsterlaw.co.uk/home",
            postLogoutRedirectUri: "https://register-test.minsterlaw.co.uk/login",
        }
    },
    apiConfig: {
        scopes: [
            "https://testb2cminster.onmicrosoft.com/api/DigitalOnboarding.Write",
            "https://testb2cminster.onmicrosoft.com/api/DigitalOnboarding.Read"],
    },
    defaultGuid: "65D1A040-7AB6-43A6-8B62-03AD630A34D0",
   maxActiveSessionDurationMin: 240,
    maxInactivityDurationMin: 30
};
